export const ANALYTICS_EVENT = "logAnalytics"; // exported for reuse in test
export const SCROLL_EVENT = "scrollToTop"; // exported for reuse in test

export enum AnalyticsActivity {
    SELECT_MORTGAGE = "selectMortgage",
    NAVIGATE_TO_SUMMARY = "navigateToSummary",
    SHOW_MORTGAGE_DETAILS = "showDetails",
    SHOW_INSURANCE_OFFER_DETAILS = "showInsuranceOfferDetails",
    INSURANCE_OFFER_ACCEPTED = "insuranceOfferAccepted",
    INSURANCE_OFFER_DECLINED = "insuranceOfferDeclined",
    EXTEND_MORTGAGE_CONFIRMED = "extendMortgage",
    LEAVE_PROCESS = "leaveProcess",
}

export enum AppComponent {
    OVERVIEW_SCREEN = "mortgageOverviewScreen",
    CONFIGURATION_SCREEN = "mortgageConfigurationScreen",
    SUMMARY_SCREEN = "mortgageSummaryScreen",
    CONFIRMATION_SCREEN = "mortgageEndScreen",
}

export enum ActivityType {
    CLICK = "click",
}

export default class EventService {
    // an element that will effectively dispatch the events
    triggerElement?: HTMLElement;

    /**
     * Sends a custom event to the parent container application (e-banking) about various actions user performs in the app.
     *
     * @param activity - the action the user has performed
     * @param appComponent - which whvo appComponent (screen) is involved
     */
    sendAnalyticsEvent(activity: AnalyticsActivity, appComponent: AppComponent) {
        const event = new CustomEvent(ANALYTICS_EVENT, {
            bubbles: true, // propagate "upwards"
            composed: true, // allows the event to pass the shadow dom boundary
            detail: {
                params: {
                    userActivityName: activity,
                    userActivitySourceComponent: appComponent,
                    activityType: ActivityType.CLICK,
                    userActivityData: "", // at the moment not used, might be needed in the future
                },
            },
        });
        this.triggerElement?.dispatchEvent(event);
        console.debug(`Sent whvo analytics event for activity: '${activity}' and app component: '${appComponent}'`);
    }

    /**
     * Sends a custom event to notify the parent container to scroll the window to top because the parent controls the entire page.
     */
    sendScrollToTopEvent() {
        const event = new CustomEvent(SCROLL_EVENT, {
            bubbles: true,
            composed: true,
        });
        this.triggerElement?.dispatchEvent(event);
        console.debug("Sent whvo scrollToTop event");
    }

    /**
     * Allows setting (or changing) the trigger element after the service has been instantiated.
     */
    setTriggerElement(triggerElement: HTMLElement) {
        this.triggerElement = triggerElement;
    }

    /**
     * Returns the trigger element.
     */
    getTriggerElement() {
        return this.triggerElement;
    }
}
